import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/claimevent';
export interface ClaimEvent {
  id: number;
  caseNumber: string;
  idNumber: string;
  eventType?: number;
  transferDateForTreatment: Date;
  decisionDate: Date;
  decisionType: number;
  eventNumber: string;
  submissionDate?: Date;
  pgimaNumber: string;
  organ?: string;
  sick?: string;
  sickDetails?: string;
  organDetails?: string;
  treatmentStage: number;
  treatStepsGroupId?: number;
  updateRowDate: Date;
  statusDate?: Date;
  endStatusDate?: Date;
}
export interface ClaimEventResponseItem {
  pgimaDescription: string;
  claimEvents: ClaimEvent[];
}

export interface ILastClaimEventEntries {
  claimEventId: number;
  pgimaNumber: string;
  pgimaDescription: string;
  statusType: number;
  statusDate: Date;
  decisionType: number;
}

export const getClaimEvents = async () => {
  const claimEvents = await api.get<ClaimEventResponseItem[]>(
    addImposterToUrl(baseURL, true)
  );
  if (claimEvents.data) return claimEvents.data;
};

export const getClaimEventByNumber = async (claimEventNumber: string) => {
  const claimEvent = await api.get<ClaimEventResponseItem>(
    addImposterToUrl(`${baseURL}/${claimEventNumber}`, true)
  );
  if (claimEvent.data) return claimEvent.data;
};

export const getLastClaimEventEntries = async () => {
  const lastClaimEventEntries = await api.get<ILastClaimEventEntries[]>(
    addImposterToUrl(`${baseURL}/LastEntries`, true)
  );
  if (lastClaimEventEntries.data) return lastClaimEventEntries.data;
};
